export default "dist/images/components-columns-width-control-2-3.dd648a4.png";